var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        { staticClass: "menu-wrapper" },
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          _vm.onlyOneChild.noShowingChildren &&
          !_vm.item.alwaysShow
            ? [
                _c(
                  "app-link",
                  { attrs: { to: _vm.resolvePath(_vm.onlyOneChild.path) } },
                  [
                    _c(
                      "el-menu-item",
                      {
                        class: { "submenu-title-noDropdown": !_vm.isNest },
                        attrs: {
                          index: _vm.resolvePath(_vm.onlyOneChild.path),
                        },
                      },
                      [
                        !_vm.isCollapse
                          ? _c("item", {
                              attrs: { title: _vm.onlyOneChild.title },
                            })
                          : _c("div", { staticClass: "title-item" }, [
                              _vm._v(_vm._s(_vm.onlyOneChild.title)),
                            ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  attrs: {
                    "popper-class": "popper-class",
                    index: _vm.resolvePath(_vm.item.path),
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      !_vm.isCollapse
                        ? _c("item", { attrs: { title: _vm.item.title } })
                        : _c("div", { staticClass: "title-item" }, [
                            _vm._v(_vm._s(_vm.item.title)),
                          ]),
                    ],
                    1
                  ),
                  _vm._l(_vm.item.children, function (child, index) {
                    return _c("sidebar-item", {
                      key: child.path + index,
                      staticClass: "nest-menu",
                      attrs: {
                        "is-nest": true,
                        item: child,
                        "base-path": _vm.resolvePath(child.path),
                      },
                    })
                  }),
                ],
                2
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }